import React from 'react';
import { PeriodOption, PERIOD_OPTIONS } from '../../hooks/useUserFactsDashboard';
import { cn } from '../../utils/cn';

interface PeriodSelectorProps {
  value: PeriodOption;
  onChange: (period: PeriodOption) => void;
  className?: string;
  disabled?: boolean;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  value,
  onChange,
  className,
  disabled = false
}) => {
  const periods = Object.entries(PERIOD_OPTIONS) as [PeriodOption, typeof PERIOD_OPTIONS[PeriodOption]][];

  return (
    <div className={cn('inline-flex rounded-lg bg-rm-bg-50 p-1', className)}>
      {periods.map(([key, config]) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          disabled={disabled}
          className={cn(
            'px-3 py-1.5 text-xs font-medium rounded-md transition-all duration-200',
            value === key
              ? 'bg-white text-rm-primary-700 shadow-soft'
              : 'text-rm-neutral-600 hover:text-rm-ink-900',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
          title={config.label}
        >
          {config.shortLabel}
        </button>
      ))}
    </div>
  );
};

// Dropdown variant for mobile or compact layouts
interface PeriodDropdownProps {
  value: PeriodOption;
  onChange: (period: PeriodOption) => void;
  className?: string;
  disabled?: boolean;
}

export const PeriodDropdown: React.FC<PeriodDropdownProps> = ({
  value,
  onChange,
  className,
  disabled = false
}) => {
  const periods = Object.entries(PERIOD_OPTIONS) as [PeriodOption, typeof PERIOD_OPTIONS[PeriodOption]][];

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as PeriodOption)}
      disabled={disabled}
      className={cn(
        'px-3 py-2 text-sm border border-rm-neutral-600/30 rounded-card bg-white text-rm-ink-900',
        'focus:outline-none focus:ring-2 focus:ring-rm-accent-500 focus:border-rm-accent-500',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
      )}
    >
      {periods.map(([key, config]) => (
        <option key={key} value={key}>
          {config.label}
        </option>
      ))}
    </select>
  );
};

export default PeriodSelector;
